/*
*   配时日志管理组件
*   zxw
*   2024-05-22
*/
import React , { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Input, Select, Tag } from 'antd';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';

const Option = Select.Option;

class Lists extends Component{
    constructor(props){
        super(props);
        this.state = {
            dataLists: this.props.dataLists
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    render(){
        const columns = [
            {title: '',width: 20,dataIndex: '',key: 'key',fixed: 'left',},
            {title: '操作者',dataIndex: 'operation',key: 'operation',fixed: 'left',},
            {title: '配时ulid',dataIndex: 'timing_ulid',key: 'timing_ulid',},
            {title: '动作', dataIndex: 'action', key: 'action', },
            {title: '时段',dataIndex: 'time_period',key: 'time_period',},
            {title: '方向',dataIndex: 'direction',key: 'direction',},
            {title: '星期',key: 'week',
                render: (record) => {
                    return <>
                        {
                            record.week && record.week.length>0 && record.week.map((item) => {
                                switch(item){
                                    case '1':
                                        return <Tag color='blue'>星期一</Tag>
                                    case '2':
                                        return <Tag color='blue'>星期二</Tag>
                                    case '3':
                                        return <Tag color='blue'>星期三</Tag>
                                    case '4':
                                        return <Tag color='blue'>星期四</Tag>
                                    case '5':
                                        return <Tag color='blue'>星期五</Tag>
                                    case '6':
                                        return <Tag color='cyan'>星期六</Tag>
                                    case '0':
                                        return <Tag color='cyan'>星期日</Tag>
                                    default:
                                        return ''
                                }
                            })
                        }
                    </>
                }
            },
            {title: '时长(s)',key: 'duration',
                render: (record) => {
                    if(parseInt(record.duration) === 0){
                        return <Tag color='gold'>黄闪</Tag>
                    }else if(parseInt(record.duration) === -1){
                        return <Tag color='green'>常绿</Tag>
                    }else if(parseInt(record.duration) === -2){
                        return <Tag color='red'>关闭</Tag>
                    }else{
                        return <span>{record.duration}</span>
                    }
                }
            },
            {title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: 170,},
        ];
        return(
            <div>
                <Table 
                    columns={columns} 
                    className='content-table-row'
                    size='middle'
                    dataSource={this.state.dataLists} 
                    scroll={{ x: this.props.x}} 
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: winWidth>1440?CNF.pageSize:CNF.pageSize-2,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current,pageSize) => this.props.changePageSize(pageSize,current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
            </div>
        );
    }
}

class CPT extends Component{
    constructor(props){
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            operation: '',
            timingUlid: '',
            action: ''
        }
    }

    isRefresh = () =>{this.setState({isRefresh: this.state.isRefresh===1 ? 0:1});}
    search = () => {this.setState({currentIndex: 1});this.isRefresh();}
    changeOperation = (e) =>{this.setState({operation: e.target.value});this.search();}
    changeTimingUlid = (e) =>{this.setState({timingUlid: e.target.value});this.search();}
    changAction = (value) =>{this.setState({action: value});this.search();}
    changeIndex = (index) =>{this.setState({currentIndex: index});this.isRefresh();}

    /**
     * 获取操作日志列表
     */
    getLists(){
        const _this = this;
        const params = {
            'operation': this.state.operation,
            'timing_ulid': this.state.timingUlid,
            'action': this.state.action,
            'page_size': winWidth>1440?CNF.pageSize:CNF.pageSize-2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/timings${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    }else{
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }

    componentDidUpdate(){
        if(this.state.init !== this.state.isRefresh){
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount(){
        this.getLists();
    }

    render(){
        return(
            <div>
                <Row style={{ height: 60, paddingTop:10, paddingLeft:20 }}>
                    <Col span={3}>
                        <Input
                            onChange={this.changeOperation}
                            onPressEnter={this.search}
                            placeholder='操作者...'
                            value={this.state.operation}
                        />
                    </Col>
                    <Col span={5} style={{ marginLeft: 5 }}>
                        <Input
                            onChange={this.changeTimingUlid}
                            onPressEnter={this.search}
                            placeholder='配时ulid...'
                            value={this.state.timingUlid}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: 5 }}>
                        <Select defaultValue={''} style={{ width: '100%' }} onChange={this.changAction}>
                            <Option value=''>请选择动作</Option>
                            {
                                CNF.actions && CNF.actions.map((item) => {
                                    return <Option key={item} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists 
                            dataLists={this.state.dataLists} 
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount} 
                            changeIndex={this.changeIndex} 
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT